<div class="row gdpr-banner-container" [@show]="status">
  <div
    class="gdpr-banner-text"
    mkpDataTest="gdpr-link"
    [innerHTML]="'GDPR.BANNER' | translate | gdprLink"
  ></div>
  <ui-button mkpDataTest="gdpr-btn" [config]="gdprBtnConfig" (click)="close()">
    {{ 'GDPR.BTN-OK' | translate }}
  </ui-button>
</div>
